export default "__VITE_ASSET__DtnAdrU8__"